<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      isRouterAlive: true,
      indexmsgnum: 1,
      token: localStorage.getItem("sessionToken"),
      nickname: localStorage.getItem("nickname"),
      city: localStorage.getItem("city") ? localStorage.getItem("city") : "上海"
    };
  },

  methods: {
    selectcity() {
      this.$router.push({
        path: "city"
      });
    }
  }
};
</script>

<style lang="less">
input {
  outline: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
// //定义一个变量和一个mixin
// @baseFontSize: 19.2; //基于视觉稿横屏尺寸/100得出的基准font-size
// .px2rem(@name, @px) {
//   @{name}: @px / @baseFontSize * 0.1rem;
// }

// @baseFontSizeM: 7.5; //基于视觉稿横屏尺寸/100得出的基准font-size
// .px2remM(@name, @px) {
//   @{name}: @px / @baseFontSizeM * 0.1rem;
// }

// .px2remM_2(@name,@px) {
//   @{name}: calc(~"100%" - @px / @baseFontSizeM * 0.1rem);
// }

html {
  font-size: 625%;
  -webkit-tap-highlight-color: transparent;
}
.top {
  display: flex;
  justify-content: space-between;
  padding-top: 0.1rem !important;
  .top_location {
    padding-top: 0rem;
    font-size: 0.14rem;
    flex: 1;
    justify-content: flex-start;
    text-align: left;
    .loc_icon {
      width: 0.12rem;
      height: 0.15rem;
      margin-right: 0.05rem;
    }
    .change_city {
      color: #1395ff;
      cursor: pointer;
    }
  }
  .top_user {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    line-height: 0.25rem;
    .user_center {
      font-size: 0.14rem;
    }
    .style {
      color: #1395ff;
      margin-right: 0.14rem;
    }
    .msg {
      margin-left: 0.2rem;
      width: 0.24rem;
      height: 0.2rem;
      position: relative;
      img {
        width: 100%;
      }
      .red {
        position: absolute;
        top: -0.05rem;
        right: -0.1rem;
        width: 0.2rem;
        height: 0.2rem;
        line-height: 0.2rem;
        background: #ff545a;
        border-radius: 50%;
        font-size: 0.12rem;
        color: #fff;
        text-align: center;
      }
    }
  }
  @media (max-width: 991px) {
    padding: 0.1rem 0;
    .top_location {
      font-size: 0.26rem;
      flex: 1;
      justify-content: flex-start;
      text-align: left;
      align-items: center;
      display: flex;
      .loc_icon {
        width: 0.21rem;
        height: 0.25rem;
        margin-right: 0.08rem;
      }
      .change_city {
        margin-left: 0.1rem;
        color: #1395ff;
      }
    }
    .top_user {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      line-height: 0.25rem;
      align-items: center;
      .user_center {
        font-size: 0.24rem;
      }
      .style {
        color: #1395ff;
        margin-right: 0.14rem;
      }
      .msg {
        margin-left: 0.1rem;
        width: 0.24rem;
        height: 0.2rem;
        position: relative;
        img {
          width: 100%;
        }
        .red {
          position: absolute;
          top: 0;
          right: -0.04rem;
          width: 0.08rem;
          height: 0.08rem;
          background: #ff545a;
          border-radius: 50%;
        }
      }
    }
  }
}
.head {
  height: 0.82rem;
  position: relative;

  .head_logo {
    width: 1.38rem;
    height: 0.48rem;
    margin-top: 0.26rem;
    float: left;
    img {
      width: 100%;
    }
  }
  .head_nav {
    float: right;
    margin-top: 0.51rem;
    display: flex;
    .nav_item {
      padding: 0 0.3rem;
      font-size: 0.2rem;
      color: #1b1c33;
      a {
        color: #1b1c33;
        text-decoration: none;
      }
      .router-link-exact-active {
        color: #1395ff;
        text-decoration: none;
      }
    }
    .nav_item_ac {
      color: #1395ff;
    }
  }
}
.container-head {
  width: 100%;
  margin-top: 0.6rem;
  margin-bottom: 0.2rem;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  .head-left {
    display: flex;
    align-items: center;
    font-size: 0.24rem;
    line-height: 0.26rem;
    color: #1b1c33;
    font-weight: 500;
    text-align: left;
    .icon {
      width: 0.26rem;
      height: 0.26rem;
      margin-right: 0.1rem;
      align-items: flex-start;
      display: flex;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .head-right {
    color: #8d8e99;
    justify-content: center;
    align-items: center;
    font-size: 0.2rem;
    line-height: 0.26rem;
    height: 0.26rem;
    margin-top: 0.06rem;
    display: flex;
    cursor: pointer;
    .icon {
      margin-left: 0.1rem;
      width: 0.2rem;
      height: 0.2rem;
      background: url(../static/index/notice/notice-arrow-left.png) center
        no-repeat;
      background-size: 0.2rem 0.2rem;
    }
  }
}
@media (max-width: 991px) {
  .container-head {
    width: 100%;
    margin-top: 0.6rem;
    margin-bottom: 0.2rem;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    .head-left {
      display: flex;
      align-items: center;
      font-size: 0.36rem;
      line-height: 0.36rem;
      color: #1b1c33;
      font-weight: 500;
      text-align: left;
      .icon {
        width: 0.36rem;
        height: 0.36rem;
        margin-right: 0.1rem;
        align-items: flex-start;
        display: flex;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .head-right {
      color: #8d8e99;
      justify-content: center;
      align-items: center;
      font-size: 0.24rem;
      line-height: 0.36rem;
      height: 0.36rem;
      margin-top: 0.06rem;
      display: flex;
      .icon {
        margin-left: 0.1rem;
        width: 0.24rem;
        height: 0.24rem;
        background: url(../static/index/notice/notice-arrow-left.png) center
          no-repeat;
        background-size: 0.24rem 0.24rem;
      }
    }
  }
}
.mb60 {
  margin-bottom: 0.3rem;
}
.mt30 {
  margin-top: 0.3rem;
}

.module_list_2 {
  flex-direction: column;
  width: 100%;

  .module_item_2 {
    justify-content: space-between;
    width: 100%;
    margin-bottom: 0rem;

    .m_i_2_1 {
      width: 100%;
      height: 3.66rem;
      background: #f6fbff;
      border-radius: 0.12rem;
      padding: 0.2rem;
      position: relative;
      flex-direction: column;
      align-items: center;
      display: flex;
      justify-content: center;
      .mo_icon {
        width: 3.21rem;
        height: 2.56rem;

        img {
          max-width: 100%;
        }
      }

      .mo_info {
        flex-direction: column;
        width: 100%;
        text-align: left;
        position: relative;

        .mo_title {
          font-size: 0.2rem;
          line-height: 0.2rem;
          margin-bottom: 0.2rem;
          color: #1b1c33;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.36rem;
            margin-bottom: 0;
            font-weight: bolder;
          }
        }

        .mo_desc {
          font-size: 0.16rem;
          color: #5e5e66;
          line-height: 0.16rem;
          margin-bottom: 0.2rem;
          @media (max-width: 991px) {
            font-size: 0.26rem;
            line-height: 0.3rem;
            margin-bottom: 0.14rem;
          }
        }

        .mo_price {
          font-size: 0.3rem;
          font-weight: bolder;
          color: #ff545a;
          height: 0.67rem;
          line-height: 0.67rem;

          i {
            font-size: 0.24rem;
            line-height: 0.67rem;
            font-style: normal;
          }
          @media (max-width: 991px) {
            font-size: 0.48rem;
            line-height: 0.48rem;
            margin-right: 0.1rem;
            i {
              font-size: 0.3rem;
              line-height: 0.6rem;
              font-style: normal;
            }
          }
        }
        .mo_btn {
          position: absolute;
          right: 0rem;
          bottom: 0.2rem;
          width: 0.96rem;
          height: 0.3rem;
          line-height: 0.3rem;
          text-align: center;
          font-size: 0.16rem;
          color: #ffffff;
          background: #1395ff;
          border-radius: 0.15rem;
          justify-content: center;
          cursor: pointer;
          @media (max-width: 991px) {
            width: 1.26rem;
            height: 0.4rem;
            line-height: 0.4rem;
            font-size: 0.24rem;
            border-radius: 0.2rem;
          }
        }
      }
    }

    .m_i_2_2 {
      flex-direction: column;

      .m_i_2_2_item {
        width: 100%;
        height: 1.68rem;
        background: #f6fbff;
        border-radius: 0.12rem;
        flex: 1;
        margin-bottom: 0.3rem;
        padding: 0.2rem;
        position: relative;
        display: flex;

        .mo_info {
          flex-direction: column;
          text-align: left;
          position: relative;
          width: 100%;
          .mo_title {
            font-size: 0.2rem;
            line-height: 0.2rem;
            margin-bottom: 0.2rem;
            color: #1b1c33;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.36rem;
              margin-bottom: 0;
              font-weight: bolder;
            }
          }

          .mo_desc {
            font-size: 0.16rem;
            color: #5e5e66;
            height: 0.16rem;
            margin-bottom: 0.2rem;
            @media (max-width: 991px) {
              font-size: 0.26rem;
              line-height: 0.3rem;
              margin-bottom: 0.14rem;
            }
          }

          .mo_price {
            font-size: 0.3rem;
            font-weight: bolder;
            color: #ff545a;
            height: 0.67rem;
            line-height: 0.67rem;

            i {
              font-size: 0.24rem;
              line-height: 0.67rem;
              font-style: normal;
            }
            @media (max-width: 991px) {
              font-size: 0.48rem;
              line-height: 0.48rem;
              margin-right: 0.1rem;
              i {
                font-size: 0.3rem;
                line-height: 0.6rem;
                font-style: normal;
              }
            }
          }
          .mo_btn {
            position: absolute;
            right: 0rem;
            bottom: 0rem;
            width: 0.96rem;
            height: 0.3rem;
            line-height: 0.3rem;
            text-align: center;
            font-size: 0.16rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            background: #1395ff;
            border-radius: 0.15rem;
            justify-content: center;
            cursor: pointer;
            @media (max-width: 991px) {
              width: 1.26rem;
              height: 0.4rem;
              line-height: 0.4rem;
              font-size: 0.24rem;
              border-radius: 0.2rem;
            }
          }
        }
      }
    }
  }

  .module_item_3 {
    justify-content: space-between;
    // width: 686rpx;
    flex-direction: row;
    flex-wrap: wrap;

    .m_i_3_1 {
      cursor: pointer;
      width: 100%;
      height: auto;
      background: #f6fbff;
      background-position: right;
      border-radius: 0.1rem;
      padding: 0.2rem;
      @media (max-width: 991px) {
        padding: 0.3rem;
      }
      position: relative;
      margin-bottom: 0.2rem;
      background-size: cover;
      text-align: left;

      .mo_info {
        flex-direction: column;
        position: relative;
        .mo_title {
          font-size: 0.2rem;
          color: #1b1c33;
          line-height: 0.25rem;
          margin-bottom: 0.1rem;
          height: 0.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.36rem;
            margin-bottom: 0;
            font-weight: bolder;
            height: 0.72rem;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          }
        }

        .mo_desc {
          font-size: 0.16rem;
          line-height: 0.16rem;
          margin-bottom: 0.2rem;
          color: #5e5e66;
          height: 0.16rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          @media (max-width: 991px) {
            font-size: 0.26rem;
            line-height: 0.3rem;
            margin-bottom: 0.14rem;
            height: 0.3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          }
        }

        .mo_price {
          font-size: 0.3rem;
          font-weight: bolder;
          color: #ff545a;
          height: 0.67rem;
          line-height: 0.67rem;

          i {
            font-size: 0.24rem;
            line-height: 0.67rem;
            font-style: normal;
          }
          @media (max-width: 991px) {
            font-size: 0.48rem;
            line-height: 0.48rem;
            margin-right: 0.1rem;
            i {
              font-size: 0.3rem;
              line-height: 0.6rem;
              font-style: normal;
            }
          }
        }
        .mo_btn {
          position: absolute;
          right: 0rem;
          bottom: 0.2rem;
          width: 0.96rem;
          height: 0.3rem;
          line-height: 0.3rem;
          text-align: center;
          font-size: 0.16rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          background: #1395ff;
          border-radius: 0.15rem;
          justify-content: center;
          cursor: pointer;
          @media (max-width: 991px) {
            width: 1.26rem;
            height: 0.4rem;
            line-height: 0.4rem;
            font-size: 0.24rem;
            border-radius: 0.2rem;
          }
        }
      }
    }
  }
}
.gif_img {
  //border-radius: 0.12rem;
  img {
    width: 100%;
    //border-radius: 0.12rem;
  }
}

.maybe {
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  .maybe_item {
    width: 100%;
    height: 1.8rem;
    background: #ffffff;
    box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.08);
    border-radius: 0.12rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.2rem;
    display: flex;
    cursor: pointer;

    .maybe_icon {
      margin: 0 auto 0.12rem auto;
      width: 0.7rem;
      height: 0.7rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .maybe_text {
      font-size: 0.18rem;
      font-weight: bolder;
      color: #1b1c33;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }
}
.module_list_1 {
  flex-direction: column;

  .module_item_1 {
    width: 100%;
    height: 1.98rem;
    background: #ffffff;
    box-shadow: 0px 0px 0.09rem 0px rgba(0, 0, 0, 0.09);
    border-radius: 0.12rem;
    margin-bottom: 0.2rem;
    position: relative;
    display: flex;

    .mo_icon {
      margin-top: 0.34rem;
      width: 2.85rem;
      height: 1.64rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .mo_info {
      flex-direction: column;
      margin-top: 0.3rem;
      text-align: left;
      .mo_title {
        font-size: 0.2rem;
        color: #1b1c33;
        line-height: 0.2rem;
        margin-bottom: 0.2rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.36rem;
          margin-bottom: 0;
        }
      }

      .mo_desc {
        font-size: 0.16rem;
        color: #5e5e66;
        line-height: 0.16rem;
        margin-bottom: 0.2rem;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.3rem;
          margin-bottom: 0.14rem;
        }
      }

      .mo_price {
        font-size: 0.3rem;
        font-weight: bolder;
        color: #ff545a;
        line-height: 0.67rem;

        i {
          font-size: 0.2rem;
          line-height: 0.67rem;
          font-style: normal;
        }
        @media (max-width: 991px) {
          font-size: 0.48rem;
          line-height: 0.48rem;
          margin-right: 0.1rem;
          i {
            font-size: 0.3rem;
            line-height: 0.6rem;
            font-style: normal;
          }
        }
      }
    }

    .mo_btn {
      position: absolute;
      right: 0.4rem;
      bottom: 0.4rem;
      width: 1.2rem;
      height: 0.36rem;
      line-height: 0.36rem;
      text-align: center;
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      background: #1395ff;
      border-radius: 0.18rem;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 991px) {
        width: 1.26rem;
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.24rem;
        border-radius: 0.2rem;
      }
    }

    // &:last-child {
    //   margin-bottom: 0;
    // }
  }
}
.reviewcase {
  margin-top: 0.6rem;
  padding: 0.35rem 0.28rem;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 0.09em 0px rgba(0, 0, 0, 0.09);
  border-radius: 0.12rem;
  flex-direction: column;

  .re_head {
    align-items: center;
    margin-bottom: 0.1rem;
    display: flex;
    align-items: center;
    .re_icon {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.1rem;
      display: flex;
      align-items: center;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .re_title {
      font-size: 0.24rem;
      line-height: 0.26rem;
      color: #1b1c33;

      span {
        color: rgba(19, 149, 255, 1);
      }
    }
  }

  .re_con {
    text-indent: 48rpx;
    font-size: 24rpx;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5e5e66;
    line-height: 36rpx;
    letter-spacing: 1rpx;

    .image {
      width: 100%;
      margin: 15rpx 0;
    }
  }
}
.module_list_3 {
  flex-direction: column;
  width: 100%;

  .module_item_1 {
    justify-content: space-between;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;

    .m_i_1_1 {
      width: 100%;
      height: auto;
      background: #f6fbff;
      border-radius: 0.12rem;
      padding: 0.2rem;
      position: relative;
      margin-bottom: 0.2rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .m_i_1_icon {
        width: 0.8rem;
        height: 0.72rem;
        margin: 0 auto 0.1rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .m_i_1_text {
        font-size: 0.2rem;
        line-height: 0.2rem;
        margin-bottom: 0.1rem;
        color: #1b1c33;
      }

      .m_i_1_desc {
        font-size: 0.16rem;
        color: #5e5e66;
        line-height: 0.25rem;
      }
    }
  }
}

//表单
.formbox {
  margin: 0rem auto 0 auto;
  height: auto;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.4rem;
  flex-direction: column;
  text-align: left;
  .box_title {
    font-size: 0.24rem;
    line-height: 0.33rem;
    margin-bottom: 0.2rem;
  }
  .box_img {
    width: 100%;
  }

  .dbox_cell {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.4rem;
    display: flex;

    .dbox_name {
      width: 1.12rem;
      height: 0.25rem;
      font-size: 0.18rem;
      color: #5e5e66;
      line-height: 0.25rem;
      text-align: justify;
      display: inline-block;
      text-align-last: justify;
      margin-right: 0.53rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.33rem;
        height: auto;
      }
    }

    .dbox_input {
      flex: 1;

      .input {
        width: 100%;
        height: auto;
        font-size: 0.18rem;
        line-height: 0.25rem;
        padding: 0.17rem;
        border: 0.01rem solid rgba(196, 196, 204, 1);
        background: #fff;
        color: #333;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
          height: auto;
        }
      }

      .textarea {
        width: 100%;
        height: 1.2rem;
        line-height: 0.25rem;
        padding: 0.17rem;
        border: 0.01rem solid rgba(196, 196, 204, 1);
        background: #fff;
        font-size: 0.18rem;
        color: #333;
        resize: none;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
          height: auto;
        }
      }

      .select {
        margin: 0;
        width: 100%;
        padding: 0.17rem;
        border: 0.01rem solid rgba(196, 196, 204, 1);
        background: #fff;
        align-items: center;
        justify-content: space-between;
        font-size: 0.18rem;
        color: #1b1c33;
        display: flex;
        @media (max-width: 991px) {
          //font-size: 0.28rem;
          //line-height: 0.33rem;
          //height: auto;
          //padding: 0.17rem;

          // min-height: 0.36rem;
        }
        select {
          width: 100%;
          //   height: 100%;
          //   line-height: 95%;
          border: none;
          background: transparent;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            height: 0.5rem;
            line-height: 100%;
            // line-height: 0.28rem;
            // height: auto;
            // min-height: 0.36rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .icon {
          width: 0.3rem;
          height: 0.17rem;
        }
        uni-picker {
          width: 100%;
        }
      }
    }

    .dbox_upload {
      flex: 1;
      height: auto;
      padding: 0.2rem 0;
      background: #fff;
      border: 0.01rem solid rgba(196, 196, 204, 1);
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      background-size: cover;
      background-position: center;
      display: flex;

      .upload {
        width: 0.5rem;
        height: 0.42rem;
        margin-bottom: 0.23rem;

        img {
          width: 0.5rem;
          height: 0.42rem;
        }
      }

      .upload_text {
        height: 0.25rem;
        font-size: 0.16rem;
        color: #1b1c33;
        line-height: 0.25rem;
      }

      .upload_tip {
        height: 0.2rem;
        font-size: 0.14rem;
        color: #8d8e99;
        line-height: 0.2rem;
      }

      .delete {
        position: absolute;
        top: 0;
        right: 0;
        width: 0.4rem;
        height: 0.4rem;
      }

      .img {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .btn_save {
    margin: 0.5rem auto 0.5rem auto;
    width: 2.94rem;
    height: 0.7rem;
    line-height: 0.7rem;
    background: #1395ff;
    border-radius: 0.35rem;
    font-size: 0.24rem;
    color: #ffffff;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }
}

//开票申请
.form {
  flex-direction: row;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;

  .f_title {
    font-size: 0.24rem;
    color: #1b1c33;
    line-height: 0.33rem;
    margin-bottom: 0.3rem;
    align-items: center;
    margin-left: 0.32rem;
    padding-top: 0.32rem;
    display: flex;
    width: 100%;
    @media (max-width: 991px) {
      margin-left: 0;
      font-size: 0.28rem;
    }

    .op {
      height: 0.2rem;
      font-size: 0.2rem;
      color: #1395ff;
      line-height: 0.2rem;
      align-items: center;
      display: flex;

      .op_icon {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.12rem;
        margin-left: 0.3rem;
      }
      @media (max-width: 991px) {
        height: 0.28rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        .op_icon {
          width: 0.28rem;
          height: 0.28rem;
          margin-right: 0.12rem;
          margin-left: 0.3rem;
        }
      }
    }
  }

  .f_cell {
    align-items: center;
    margin-bottom: 0.2rem;
    flex-wrap: wrap;
    width: ~"calc(50% - 0.32rem)";
    margin-left: 0.32rem;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    @media (max-width: 991px) {
      width: 100%;
      margin-left: 0rem;
    }
    .cell_title {
      width: 1.12rem;
      height: 0.25rem;
      font-size: 0.18rem;
      color: #1b1c33;
      line-height: 0.25rem;
      margin-right: 0.53rem;
      display: inline-block;
      @media (max-width: 991px) {
        height: auto;
        font-size: 0.28rem;
        line-height: 0.33rem;
      }
    }

    .cell_vaule {
      align-items: center;
      flex: 1;
      display: flex;
      .input {
        width: 100%;
        height: 100%;
        font-size: 0.18rem;
        line-height: 0.25rem;
        padding: 0.17rem;
        border: 0.01rem solid rgba(196, 196, 204, 1);
        background: #fff;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
      }

      .textarea {
        width: 100%;
        font-size: 0.18rem;
        color: #333;
        line-height: 0.25rem;
        padding: 0.17rem;
        border: 0.01rem solid rgba(196, 196, 204, 1);
        background: #fff;
        resize: none;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
      }

      .cellradio {
        margin-right: 0.2rem;
        font-size: 0.18rem;
        display: flex;
        align-items: center;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
        input[type="radio"] {
          width: 0.18rem;
          height: 0.18rem;
          margin: 0 0.1rem 0 0;
          @media (max-width: 991px) {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
        label {
          font-weight: normal;
          margin-bottom: 0;
        }
      }
      .select {
        width: 100%;
        height: 100%;
        font-size: 0.18rem;
        line-height: 0.25rem;
        padding: 0.1rem 0.17rem;
        border: 0.01rem solid rgba(196, 196, 204, 1);
        background: #fff;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
      }
    }
  }

  .tablelist {
    flex-direction: column;

    .tb_item {
      width: 100%;
      height: auto;
      overflow: hidden;
      margin-bottom: 0.3rem;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;
      align-items: flex-start;
      margin-left: 0.32rem;
      display: flex;
      @media (max-width: 991px) {
        margin-left: 0rem;
      }

      .delete {
        position: absolute;
        top: 0.17rem;
        right: 0.5rem;
        width: 0.2rem;
        height: 0.2rem;
        z-index: 2;
        @media (max-width: 991px) {
          top: 0.3rem;
          right: 0.4rem;
          width: 0.28rem;
          height: 0.28rem;
        }
      }

      .f_cell {
        width: 50%;
        align-items: center;
        margin-bottom: 0.2rem;
        margin-left: 0;

        .cell_title {
          width: 1.12rem;

          font-size: 0.18rem;
          color: #1b1c33;
          line-height: 0.25rem;
          margin-right: 0.53rem;
          display: inline-block;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.33rem;
          }
        }

        .cell_vaule {
          width: 1.89rem;
          padding-right: 0.1rem;

          .input {
            width: 100%;
            height: 100%;
            font-size: 0.18rem;
            line-height: 0.25rem;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.33rem;
            }
          }
        }

        &:nth-child(5) {
          margin-bottom: 0;
        }

        &:nth-child(6) {
          margin-bottom: 0;
        }
      }
    }
  }

  .total {
    font-size: 0.18rem;
    line-height: 0.25rem;
    color: #1b1c33;
    margin-bottom: 0.3rem;
    margin-left: 0.32rem;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      line-height: 0.33rem;
      margin-left: 0rem;
    }

    .price {
      color: #f1272e;
    }
  }
}
.btn_save_red {
  margin: 0.5rem auto 0.5rem auto;
  width: 2.94rem;
  height: 0.7rem;
  line-height: 0.7rem;
  background: #ff545a;
  border-radius: 0.35rem;
  font-size: 0.24rem;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  @media (max-width: 991px) {
    width: 5.9rem;
    height: 0.8rem;
    font-size: 0.38rem;
    border-radius: 0.4rem;
    line-height: 0.8rem;
  }
}

//服务公司
.info_data {
  flex-direction: column;

  .data_head {
    align-items: center;
    justify-content: space-between;
    display: flex;

    .data_title {
      height: 0.33rem;
      font-size: 0.24rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.33rem;
      align-items: center;
      display: flex;

      .line {
        width: 0.05rem;
        height: 0.26rem;
        background: #1395ff;
        border-radius: 0.03rem;
        margin-right: 0.05rem;
      }
    }

    .arrow_right {
      width: 0.3rem;
      height: 0.17rem;

      img {
        width: 0.3rem;
        height: 0.17rem;
      }
    }

    .data_right {
      font-size: 0.2rem;

      color: #8d8e99;
      line-height: 0.3rem;

      .right {
        margin-left: 0.1rem;
        font-size: 0.28rem;
        color: #ff545a;
        cursor: pointer;
      }
    }
  }

  .data_sn {
    height: 0.25rem;
    font-size: 0.18rem;
    color: #1395ff;
    line-height: 0.25rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    margin-left: 0.08rem;
  }

  .data_cell_list {
    flex-direction: column;

    .data_cell {
      padding: 0;
      margin-bottom: 0.2rem;
      display: flex;

      .cell_title {
        width: 1.66rem;
        line-height: 0.25rem;
        height: 0.25rem;
        font-size: 0.18rem;
        color: #1b1c33;
        margin-left: 0.08rem;
      }

      .cell_con {
        flex: 1;
        font-size: 0.18rem;
        color: #1b1c33;
        line-height: 0.25rem;
        font-weight: bolder;
      }
    }
  }

  .data_table_list {
    width: 100%;
    flex-direction: column;
    display: flex;
    .table_head {
      height: 0.3rem;
      line-height: 0.3rem;
      display: flex;
    }

    .table_li {
      display: flex;
    }
    .head_25 {
      flex: 1;
      font-size: 0.18rem;
      text-align: center;
      height: 0.3rem;
      line-height: 0.3rem;
      color: #1b1c33;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      border: 0.01rem solid rgba(196, 196, 204, 0.5);
    }

    .head_50 {
      flex: 2;
      font-size: 0.18rem;
      text-align: center;
      height: 0.3rem;
      line-height: 0.3rem;
      color: #1b1c33;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      border: 0.01rem solid rgba(196, 196, 204, 0.5);
      border-left: 0;
      border-right: 0;
    }
  }

  .data_img {
    width: 100%;

    .img_item {
      width: 2.4rem;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      display: flex;
      img {
        text-align: center;
        width: 2.4rem;
        height: 2.4rem;
        vertical-align: middle;
        margin-bottom: 0.2rem;
      }

      .item_btn {
        cursor: pointer;
        width: 1.26rem;
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.18rem;
        text-align: center;
        color: #fff;
        justify-content: center;
        background: #1395ff;
        border-radius: 0.2rem;
      }
    }
  }
}
.mt35 {
  margin-top: 0.35rem !important;
}

.mb35 {
  margin-bottom: 0.35rem !important;
}

//订单详情
.detail {
  margin: 0 auto 0.6rem;
  flex-direction: column;
  text-align: left;
  border-top: 0rem solid #f5f5f5;
  @media (max-width: 991px) {
    width: 6.86rem;
  }
}

.box_con {
  padding: 0.2rem 0.24rem;
  background: #fff;
  border: 0.01rem solid #ccc;
  border-radius: 0rem;
  margin: 0 auto 0.2rem auto;
  flex-direction: column;

  .box_title {
    font-size: 0.24rem;
    display: flex;
    color: #1b1c33;
    line-height: 0.33rem;
    justify-content: space-between;
    width: 100%;

    .more {
      font-size: 0.24rem;
      color: #8d8e99;
      background: url(../static/user/icon_8.png) center right no-repeat;
      background-size: 0.12rem 0.22rem;
      padding-right: 0.28rem;
    }
  }

  .order_status {
    width: 100%;
    justify-content: space-around;
    margin-top: 0.3rem;
    display: flex;

    .status_item {
      flex-direction: column;
      cursor: pointer;

      .item_icon {
        width: 0.6rem;
        height: 0.52rem;
        margin: 0 auto 0.16rem auto;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }
        .tip {
          position: absolute;
          top: -0.1rem;
          right: -0.1rem;
          padding: 0.05rem;
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 50%;
          background-color: #ff545a;
          font-size: 0.13rem;
          line-height: 0.14rem;
          color: #ffffff;
          text-align: center;
          justify-content: center;
        }
      }

      .item_name {
        font-size: 0.2rem;
        color: #1b1c33;
        height: 0.25rem;
        line-height: 0.25rem;
      }
    }
  }

  .service {
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;
    .service_item {
      width: 2.8rem;
      height: 1.66rem;
      background: #f8f9fd;
      border-radius: 0.1rem;
      flex-direction: column;
      margin-top: 0.1rem;
      margin-bottom: 0.2rem;

      .item_head {
        width: 100%;
        height: 0.63rem;
        border-bottom: 0.02rem solid rgba(196, 196, 204, 0.2);
        font-size: 0.2rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        display: flex;

        .head_icon {
          width: 0.26rem;
          height: 0.26rem;
          margin-right: 0.05rem;

          img {
            width: 100%;
          }
        }
      }

      .item_con {
        height: 1rem;
        align-items: center;
        justify-content: center;
        font-size: 0.4rem;
        font-weight: bolder;
        color: #1395ff;
        letter-spacing: 0.01rem;
      }

      &:nth-child(7) {
        width: 100%;
      }
    }
  }

  .module_list {
    padding: 0;
    width: 100%;
    flex-direction: column;

    .module_item {
      width: auto;
      padding: 0 0.2rem 0 0.24rem;
      height: 0.7rem;
      margin-top: 0.2rem;
      background: #f8f9fd;
      border-radius: 0.1rem;
      align-items: center;
      justify-content: space-between;
      display: flex;

      .module_name {
        align-items: center;
        display: flex;

        .name_icon {
          width: 0.33rem;
          height: 0.33rem;
          margin-right: 0.19rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name_info {
          flex-direction: column;

          .name_title {
            height: 0.25rem;
            font-size: 0.16rem;
            color: #5e5e66;
            line-height: 0.25rem;
            display: flex;

            .span {
              color: #1395ff;
              margin-left: 0.2rem;
              cursor: pointer;
            }
          }

          .name_tip {
            font-size: 0.18rem;
            color: #8d8e99;
            line-height: 0.25rem;
            height: 0.25rem;
          }
        }

        height: 0.33rem;
        font-size: 0.24rem;
        color: #5e5e66;
        line-height: 0.33rem;
      }

      .item_btn {
        cursor: pointer;
        width: 0.96rem;
        height: 0.3rem;
        background: #1395ff;
        border-radius: 0.15rem;
        line-height: 0.3rem;
        font-size: 0.14rem;
        color: #ffffff;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .info_data {
    flex-direction: column;
    text-align: left;
    .data_head {
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.07rem;

      .data_title {
        height: 0.33rem;
        font-size: 0.2rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.33rem;
        align-items: center;

        .line {
          width: 0.05rem;
          height: 0.26rem;
          background: #1395ff;
          border-radius: 0.03rem;
          margin-right: 0.05rem;
        }
      }

      .arrow_right {
        width: 0.3rem;
        height: 0.17rem;

        img {
          width: 0.3rem;
          height: 0.17rem;
        }
      }

      .data_right {
        font-size: 0.16rem;
        color: #8d8e99;
        line-height: 0.25rem;
        display: flex;

        .right {
          margin-left: 0.1rem;
          font-size: 0.15rem;
          color: #ff545a;
        }
      }
    }

    .data_sn {
      height: 0.25rem;
      font-size: 0.18rem;
      color: #1395ff;
      line-height: 0.25rem;
      margin-top: 0.1rem;
      margin-bottom: 0rem;
      margin-left: 0.08rem;
    }

    .data_cell_list {
      flex-direction: column;

      .data_cell {
        padding: 0;
        margin-bottom: 0.16rem;

        .cell_title {
          width: 1rem;
          line-height: 0.25rem;
          height: 0.25rem;
          font-size: 0.16rem;
          color: #1b1c33;
        }

        .cell_con {
          font-size: 0.16rem;
          color: #000;
          font-weight: normal;
          line-height: 0.25rem;
        }
      }
    }

    .data_table_list {
      width: 100%;
      flex-direction: column;

      .table_head {
        height: 0.4rem;
        line-height: 0.4rem;
        font-weight: bolder;
      }

      .head_25 {
        flex: 1;
        font-size: 0.16rem;
        text-align: center;
        height: 0.4rem;
        line-height: 0.4rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 0.01rem solid rgba(196, 196, 204, 0.5);
      }

      .head_50 {
        flex: 2;
        font-size: 0.16rem;
        text-align: center;
        height: 0.4rem;
        line-height: 0.4rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 0.01rem solid rgba(196, 196, 204, 0.5);
        border-left: 0;
        border-right: 0;
      }
    }

    .data_img {
      width: 100%;

      .img_item {
        width: 1.4rem;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          text-align: center;
          width: 1.4rem;
          height: auto;
          vertical-align: middle;
          margin-bottom: 0.2rem;
        }

        .item_btn {
          cursor: pointer;
          width: 0.86rem;
          height: 0.32rem;
          line-height: 0.32rem;
          font-size: 0.14rem;
          text-align: center;
          color: #fff;
          justify-content: center;
          background: #1395ff;
          border-radius: 0.16rem;
        }
      }
    }
  }
}
.no_data {
  height: 100%;
  width: 100%;
  margin: 1rem 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;

  .no_icon {
    width: 2.75rem;
    height: 2.31rem;
    margin-bottom: 0.3rem;
    background: url(../static/nodata.png) no-repeat;
    background-size: cover;
  }

  .no_text {
    font-size: 0.2rem;
    color: #353535;
  }
}
.gomore {
  margin: 0.3rem auto;
  cursor: pointer;
  font-size: 0.2rem;
  text-align: center;
  @media (max-width: 991px) {
    font-size: 0.28rem;
  }
}
.container {
  @media (max-width: 991px) {
    padding: 0 !important;
  }
}
.mint-msgbox {
  width: 6rem;
}
.mint-toast {
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue